import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-mb-2 p-p-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MasterDataUploadForm = _resolveComponent("MasterDataUploadForm")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_MasterDataUploadForm, {
        selectedFiles: _ctx.files,
        showErrorMessage: _ctx.showErrorMessage,
        onUpdate: _ctx.onUpdate,
        onFileUploader: _ctx.fileUploader
      }, null, 8, ["selectedFiles", "showErrorMessage", "onUpdate", "onFileUploader"])
    ]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showWarningDialog,
      onOnClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showWarningDialog = false)),
      onOnConfirm: _ctx.startFileUpload,
      headerText: _ctx.$t('Squeeze.MasterData.CreateResetTable'),
      saveButtonText: _ctx.$t('Squeeze.General.Execute')
    }, {
      content: _withCtx(() => [
        _createElementVNode("b", null, _toDisplayString(_ctx.$t('Squeeze.MasterData.Attention')), 1),
        _createTextVNode(": " + _toDisplayString(_ctx.$t('Squeeze.MasterData.CreateResetTableConfirm')), 1)
      ]),
      _: 1
    }, 8, ["show", "onOnConfirm", "headerText", "saveButtonText"]),
    _createVNode(_component_Dialog, {
      header: _ctx.$t('Squeeze.General.Info'),
      visible: _ctx.showImportErrors,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showImportErrors) = $event)),
      modal: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Message, {
          closable: false,
          severity: "info"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.MasterData.SuccessButWithErrors')), 1),
            _hoisted_2,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('Squeeze.MasterData.CountOfErrors', {errorNumber: _ctx.errorCount})), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Message, {
          closable: false,
          severity: "error"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importErrors, (error) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: error }, [
                _createTextVNode(_toDisplayString(error), 1),
                _hoisted_3
              ], 64))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["header", "visible"])
  ], 64))
}